import styled from "styled-components";
import styles from "./homeSectionOne.module.css";

const SvgOne = () => (
  <svg width="47" height="48" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.775391" width="20.7839" height="20.7839" rx="2.36181" fill="#B8C3E9" />
    <rect y="26.9922" width="20.7839" height="20.7839" rx="2.36181" fill="#6C8EF8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.6132 26.9922C33.9692 26.9922 32.6365 28.3249 32.6365 29.9689V34.4079L28.1984 34.4079C26.5544 34.4079 25.2217 35.7406 25.2217 37.3846C25.2217 39.0286 26.5544 40.3613 28.1984 40.3613H32.6365V44.7994C32.6365 46.4434 33.9692 47.7761 35.6132 47.7761C37.2572 47.7761 38.5899 46.4434 38.5899 44.7994V40.3613H43.0289C44.6729 40.3613 46.0056 39.0286 46.0056 37.3846C46.0056 35.7406 44.6729 34.4079 43.0289 34.4079L38.5899 34.4079V29.9689C38.5899 28.3249 37.2572 26.9922 35.6132 26.9922Z"
      fill="#B8C3E9"
    />
    <rect x="25.2227" y="0.775391" width="20.7839" height="20.7839" rx="2.36181" fill="#6C8EF8" />
  </svg>
);
const SvgTwo = () => (
  <svg width="70" height="69" viewBox="0 0 70 69" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="35.2412"
      cy="34.4685"
      r="26.2772"
      transform="rotate(-67.7966 35.2412 34.4685)"
      fill="#6C8EF8"
    />
    <path
      d="M53.8586 23.6084C56.2518 27.7118 57.2224 32.4909 56.6195 37.2027C56.0166 41.9146 53.874 46.2953 50.5247 49.6639C47.1753 53.0324 42.807 55.2002 38.0987 55.8301C33.3903 56.46 28.6058 55.5168 24.4888 53.1472C20.3718 50.7775 17.1529 47.1141 15.3326 42.7264C13.5123 38.3387 13.1925 33.4726 14.4229 28.8844C15.6533 24.2963 18.3651 20.2431 22.1365 17.355"
      stroke="#DEDEDE"
      strokeWidth="2.72012"
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.5411 24.9747C35.5411 24.2831 35.2664 23.6199 34.7774 23.1309C34.2884 22.6419 33.6252 22.3672 32.9336 22.3672C32.2421 22.3672 31.5789 22.6419 31.0899 23.1309C30.6009 23.6199 30.3262 24.2831 30.3262 24.9747V35.4046C30.3263 36.0961 30.6011 36.7592 31.0902 37.2481L38.4641 44.6246C38.7064 44.8669 38.994 45.059 39.3105 45.1902C39.627 45.3213 39.9663 45.3888 40.3089 45.3888C40.6515 45.3888 40.9908 45.3213 41.3073 45.1902C41.6238 45.059 41.9114 44.8669 42.1537 44.6246C42.396 44.3824 42.5881 44.0947 42.7192 43.7782C42.8503 43.4617 42.9178 43.1224 42.9178 42.7798C42.9178 42.4372 42.8503 42.098 42.7192 41.7814C42.5881 41.4649 42.396 41.1773 42.1537 40.935L35.5411 34.3251V24.9747Z"
      fill="#DEDEDE"
    />
    <circle cx="40.1976" cy="13.5052" r="1.181" fill="#DEDEDE" />
    <circle cx="31.8275" cy="12.9134" r="1.181" fill="#DEDEDE" />
    <circle cx="47.0501" cy="16.308" r="1.181" fill="#DEDEDE" />
  </svg>
);
const SvgThree = () => (
  <svg width="53" height="41" viewBox="0 0 53 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M30.1594 0.363282C31.7378 0.363282 33.2516 0.999663 34.3677 2.13243C35.4838 3.26519 36.1108 4.80155 36.1108 6.40352L6.35376 6.40352L6.35376 30.5645C4.77534 30.5645 3.26158 29.9281 2.14547 28.7953C1.02937 27.6626 0.402344 26.1262 0.402344 24.5242L0.402345 6.40352C0.402345 4.80155 1.02937 3.26519 2.14547 2.13243C3.26158 0.999661 4.77534 0.363281 6.35376 0.363281L30.1594 0.363282Z"
      fill="#B8C3E9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5488 10.7363C13.589 10.7363 12.6684 11.1176 11.9897 11.7964C11.311 12.4751 10.9297 13.3956 10.9297 14.3555V37.2124C10.9297 38.1722 11.311 39.0928 11.9897 39.7715C12.6684 40.4502 13.589 40.8315 14.5488 40.8315H48.7437C49.7035 40.8315 50.6241 40.4502 51.3028 39.7715C51.9815 39.0928 52.3628 38.1722 52.3628 37.2124V14.3555C52.3628 13.3956 51.9815 12.4751 51.3028 11.7964C50.6241 11.1176 49.7035 10.7363 48.7437 10.7363H14.5488ZM48.7437 37.2124H14.5488L25.9131 17.9746L35.9518 33.5932L42.0669 21.5938L48.7437 37.2124Z"
      fill="#6C8EF8"
    />
  </svg>
);
const SvgFour = () => (
  <svg width="58" height="57" viewBox="0 0 58 57" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M36.1696 42.7507C36.2228 41.5455 36.9069 40.4607 37.8605 39.7057C40.1742 37.881 41.8619 35.3808 42.6891 32.5527C43.5163 29.7246 43.4419 26.709 42.4763 23.9251C41.5106 21.1412 39.7016 18.7273 37.3008 17.0189C34.8999 15.3106 32.0265 14.3926 29.0799 14.3926C26.1332 14.3926 23.2598 15.3106 20.859 17.0189C18.4581 18.7273 16.6492 21.1412 15.6835 23.9251C14.7178 26.709 14.6434 29.7246 15.4706 32.5527C16.2978 35.3808 17.9856 37.881 20.2992 39.7057C21.2563 40.4607 21.937 41.5455 21.9866 42.7507H36.1731H36.1696Z"
      fill="#6C8EF8"
    />
    <path
      d="M32.6226 3.75581C32.6226 2.81565 32.2491 1.914 31.5843 1.24921C30.9195 0.584413 30.0179 0.210938 29.0777 0.210938C28.1375 0.210938 27.2359 0.584413 26.5711 1.24921C25.9063 1.914 25.5328 2.81565 25.5328 3.75581V7.30067C25.5328 8.24083 25.9063 9.14248 26.5711 9.80727C27.2359 10.4721 28.1375 10.8455 29.0777 10.8455C30.0179 10.8455 30.9195 10.4721 31.5843 9.80727C32.2491 9.14248 32.6226 8.24083 32.6226 7.30067V3.75581ZM49.131 13.529C49.7767 12.8604 50.134 11.965 50.126 11.0355C50.1179 10.1061 49.7451 9.21699 49.0878 8.55975C48.4306 7.9025 47.5415 7.52969 46.612 7.52161C45.6826 7.51354 44.7871 7.87084 44.1186 8.51656L41.6124 11.0228C40.9666 11.6914 40.6093 12.5868 40.6174 13.5163C40.6255 14.4457 40.9983 15.3348 41.6555 15.9921C42.3128 16.6493 43.2019 17.0221 44.1313 17.0302C45.0608 17.0383 45.9562 16.681 46.6248 16.0352L49.131 13.529ZM57.4366 28.5699C57.4366 29.51 57.0632 30.4117 56.3984 31.0765C55.7336 31.7413 54.8319 32.1148 53.8918 32.1148H50.3469C49.4067 32.1148 48.5051 31.7413 47.8403 31.0765C47.1755 30.4117 46.802 29.51 46.802 28.5699C46.802 27.6297 47.1755 26.7281 47.8403 26.0633C48.5051 25.3985 49.4067 25.025 50.3469 25.025H53.8918C54.8319 25.025 55.7336 25.3985 56.3984 26.0633C57.0632 26.7281 57.4366 27.6297 57.4366 28.5699ZM11.5306 16.0352C11.8576 16.3738 12.2488 16.6439 12.6812 16.8296C13.1137 17.0154 13.5789 17.1132 14.0496 17.1173C14.5203 17.1214 14.9871 17.0317 15.4227 16.8535C15.8584 16.6752 16.2541 16.412 16.587 16.0792C16.9198 15.7463 17.183 15.3505 17.3613 14.9149C17.5395 14.4792 17.6292 14.0125 17.6251 13.5418C17.621 13.0711 17.5232 12.6059 17.3375 12.1734C17.1517 11.7409 16.8816 11.3498 16.543 11.0228L14.0368 8.51656C13.3683 7.87084 12.4728 7.51354 11.5434 7.52161C10.6139 7.52969 9.7248 7.9025 9.06756 8.55975C8.41031 9.21699 8.0375 10.1061 8.02942 11.0355C8.02135 11.965 8.37865 12.8604 9.02438 13.529L11.5306 16.0352ZM11.3534 28.5699C11.3534 29.51 10.9799 30.4117 10.3151 31.0765C9.6503 31.7413 8.74864 32.1148 7.80849 32.1148H4.26362C3.32346 32.1148 2.42181 31.7413 1.75702 31.0765C1.09223 30.4117 0.71875 29.51 0.71875 28.5699C0.71875 27.6297 1.09223 26.7281 1.75702 26.0633C2.42181 25.3985 3.32346 25.025 4.26362 25.025H7.80849C8.74864 25.025 9.6503 25.3985 10.3151 26.0633C10.9799 26.7281 11.3534 27.6297 11.3534 28.5699Z"
      fill="#B8C3E9"
    />
    <path
      d="M21.9893 49.8378V46.293H36.1687V49.8378C36.1687 51.7182 35.4218 53.5215 34.0922 54.851C32.7626 56.1806 30.9593 56.9276 29.079 56.9276C27.1987 56.9276 25.3954 56.1806 24.0658 54.851C22.7362 53.5215 21.9893 51.7182 21.9893 49.8378Z"
      fill="#B8C3E9"
    />
  </svg>
);

const StyledImage = styled.img`
  max-height: 600px;
  height: 600px;
  width: auto;
  @media screen and (max-width: 992px) {
    flex: 1;
  }
`;
const StyledText = styled.div`
  max-width: 600px;
  @media screen and (max-width: 992px) {
    width: 100%;
  }
`;
const StyledRow = styled.div`
  gap: 2rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2rem 0;
  @media screen and (max-width: 992px) {
    flex-direction: column;
  }
  > * {
    > * {
      text-align: left !important;
      @media screen and (max-width: 992px) {
        text-align: center !important;
      }
    }
  }
`;

const StyledGridRow = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
`;

export const Grid = () => {
  return (
    <section className={styles.home_one__section_main}>
      <div className={styles.home_one__wrapper}>
        <StyledGridRow>
          <div className={styles.home_one__block}>
            <div className={styles.home_one__section}>
              <SvgOne />
              <label className={styles.home_one__label}>Delete from 30+ services</label>
              <div>
                Delete your old data from all of your most-used services, including Discord, Reddit,
                Twitter, Facebook, and more!
              </div>
            </div>
          </div>
          <div className={styles.home_one__block}>
            <div className={styles.home_one__section}>
              <SvgTwo />
              <label className={styles.home_one__label}>Scheduled Deletion</label>
              <div>
                Schedule the deletion of your old posts every 3 months, 6 months, 1 year, or at
                whatever cadence you prefer.
              </div>
            </div>
          </div>
          <div className={styles.home_one__block}>
            <div className={styles.home_one__section}>
              <SvgThree />
              <label className={styles.home_one__label}>Delete all types of content</label>
              <div>
                Delete your posts, DMs, photos, videos, likes, and other unique content on various
                social networks.
              </div>
            </div>
          </div>
          <div className={styles.home_one__block}>
            <div className={styles.home_one__section}>
              <SvgFour />
              <label className={styles.home_one__label}>Smart Deletion</label>
              <div>Delete by keyword, sentiment, content type, and more!</div>
            </div>
          </div>
        </StyledGridRow>
      </div>
    </section>
  );
};

const homeSectionOne = () => {
  return (
    <section className={styles.home_one__section_main}>
      <div className={styles.home_one__wrapper}>
        <StyledRow>
          <StyledText>
            <h2>Expanding Services</h2>
            <p>
              We are always looking for new services we can offer redaction for, you can suggest
              services that you would like us to support feel free to drop us an email.
            </p>
          </StyledText>
          <StyledImage
            src="/images/mobile-android3.png"
            alt="mobile preview"
            height={1657}
            width={1070}
          />
        </StyledRow>
      </div>
    </section>
  );
};

export default homeSectionOne;
